'use strict';

;( () => {
	const html = document.querySelector( 'html' );
	html.classList.remove( 'no-js' );
	html.classList.add( 'js' );
})();
